import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import { useAuthStore } from "../stores/auth-store.js";
import * as m from "../paraglide/messages.js";

const searchSchema = z.object({
  // z.coerce.string(): TanStack Router parses `?welcome=1` as the number 1, and
  // a bare z.string() would reject it with an invalid_type error (same bug as
  // ?verified=1 on the login page). Coerce so `1` is accepted as "1".
  welcome: z.coerce.string().optional(),
});

export const Route = createFileRoute("/auth/callback")({
  validateSearch: searchSchema,
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      await useAuthStore.getState().checkAuth();
      if (cancelled) return;

      const { isAuthenticated, tenant } = useAuthStore.getState();
      if (isAuthenticated) {
        // Workspace-less OAuth users (new sign-up, or no workspace yet) go to
        // onboarding to create/join a workspace — same as email/password login.
        if (tenant === null) {
          void navigate({ to: "/welcome", replace: true });
        } else {
          void navigate({ to: "/dashboard", replace: true });
        }
      } else {
        void navigate({
          to: "/login",
          search: { error: "oauth" },
          replace: true,
        });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <div
          role="status"
          aria-label={m.auth_callback_signing_in()}
          className="size-8 animate-spin rounded-full border-2 border-[var(--color-border-default)] border-t-[var(--color-accent-amber)]"
        />
        <p className="text-[14px] text-[var(--color-text-muted)]">
          {m.auth_callback_signing_in()}
        </p>
      </div>
    </main>
  );
}
